import { FC } from 'react';
import { ConfirmationModal } from '@new/common/ui/ConfirmationModal/ConfirmationModal';
import { formatPrice } from '../lib/formatPrice';

interface ConfirmSubscribeModalProps {
  isOpen: boolean;
  degreeName?: string;
  price: number;
  subPrice: number;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmSubscribeModal: FC<ConfirmSubscribeModalProps> = ({
  isOpen,
  degreeName,
  price,
  subPrice,
  isSubmitting,
  onClose,
  onConfirm,
}) => {
  const description = degreeName
    ? `You're about to subscribe and enroll in ${degreeName}.`
    : "You're about to start your subscription.";

  return (
    <ConfirmationModal
      isOpen={isOpen}
      title="Confirm your subscription"
      description={description}
      confirmText="Confirm & Pay"
      confirmVariant="primary"
      isLoading={isSubmitting}
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <div className="flex flex-col gap-2 rounded-xl border border-(--primary-O900) bg-(--primary-O200) p-4">
        <div className="flex items-center justify-between">
          <span className="[font-size:var(--fs-p3)]! text-(--neutral-black-NB700)!">
            One-time registration fee (today)
          </span>
          <span className="[font-size:var(--fs-p2)]! font-semibold text-(--neutral-black-NB1000)!">
            {formatPrice(price)}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <span className="[font-size:var(--fs-p3)]! text-(--neutral-black-NB700)!">
            Monthly (starts in 30 days)
          </span>
          <span className="[font-size:var(--fs-p2)]! font-semibold text-(--neutral-black-NB1000)!">
            {formatPrice(subPrice)}
          </span>
        </div>
      </div>
    </ConfirmationModal>
  );
};
